// extracted by mini-css-extract-plugin
module.exports = {"Form":"Contact_Form__3xZ6e","h1":"Contact_h1__31-MX"};